/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Timeline_Zoom_InInputs */

const en_shortcut_keys_desc_timeline_zoom_in = /** @type {(inputs: Shortcut_Keys_Desc_Timeline_Zoom_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoom in on the Timeline`)
};

const fr_shortcut_keys_desc_timeline_zoom_in = /** @type {(inputs: Shortcut_Keys_Desc_Timeline_Zoom_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoomer sur la timeline`)
};

const de_shortcut_keys_desc_timeline_zoom_in = /** @type {(inputs: Shortcut_Keys_Desc_Timeline_Zoom_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitleiste vergrößern`)
};

const it_shortcut_keys_desc_timeline_zoom_in = /** @type {(inputs: Shortcut_Keys_Desc_Timeline_Zoom_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingrandisci la sequenza temporale`)
};

const ru_shortcut_keys_desc_timeline_zoom_in = /** @type {(inputs: Shortcut_Keys_Desc_Timeline_Zoom_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Увеличьте масштаб временной шкалы.`)
};

const es_shortcut_keys_desc_timeline_zoom_in = /** @type {(inputs: Shortcut_Keys_Desc_Timeline_Zoom_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ampliar la línea de tiempo`)
};

const zh_cn2_shortcut_keys_desc_timeline_zoom_in = /** @type {(inputs: Shortcut_Keys_Desc_Timeline_Zoom_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`放大时间线`)
};

const ja_shortcut_keys_desc_timeline_zoom_in = /** @type {(inputs: Shortcut_Keys_Desc_Timeline_Zoom_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイムラインを拡大する`)
};

const hi_shortcut_keys_desc_timeline_zoom_in = /** @type {(inputs: Shortcut_Keys_Desc_Timeline_Zoom_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टाइमलाइन पर ज़ूम इन करें`)
};

const pt_pt2_shortcut_keys_desc_timeline_zoom_in = /** @type {(inputs: Shortcut_Keys_Desc_Timeline_Zoom_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aproxime o zoom na Linha do Tempo`)
};

/**
* | output |
* | --- |
* | "Zoom in on the Timeline" |
*
* @param {Shortcut_Keys_Desc_Timeline_Zoom_InInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_timeline_zoom_in = /** @type {((inputs?: Shortcut_Keys_Desc_Timeline_Zoom_InInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Timeline_Zoom_InInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_timeline_zoom_in(inputs)
	if (locale === "de") return de_shortcut_keys_desc_timeline_zoom_in(inputs)
	if (locale === "it") return it_shortcut_keys_desc_timeline_zoom_in(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_timeline_zoom_in(inputs)
	if (locale === "es") return es_shortcut_keys_desc_timeline_zoom_in(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_timeline_zoom_in(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_timeline_zoom_in(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_timeline_zoom_in(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_timeline_zoom_in(inputs)
	return en_shortcut_keys_desc_timeline_zoom_in(inputs)
});